export default __webpack_public_path__ + "static/logo2-790d9385cdc420ad7e117ac9bd09fb1d.png";